import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';

import MenuItem from 'components/MenuItem';
import messages from 'containers/ASIDashboard/messages';
import PAGES from 'routes/pages';
import { translate } from 'helpers/intl';

const ActionButtons = (props: {
  intl: IntlShape;
  setDetailsPageBreadcrumbsPath: Function;
}) => (
  <React.Fragment>
    <MenuItem
      setDetailsPageBreadcrumbsPath={props.setDetailsPageBreadcrumbsPath}
      openServices={() => {}}
      items={[
        {
          title: translate({ ...messages.contractsAndGuarantees }, props),
          icon: 'contractsAndGuaranteesAMC',
          path: PAGES.ASI_DETAILS,
          BreadcrumbsPath: [
            {
              name: 'asi',
              route: PAGES.ASI_DASHBOARD,
            },
            {
              name: 'contractEtGarantie',
            },
          ],
        },
      ]}
    />
  </React.Fragment>
);

export default injectIntl(ActionButtons);
